// extracted by mini-css-extract-plugin
export default {"cardBase":"styles_cardBase__FUJ+F","card":"styles_card__S9XDm"};